<template>
  <b-form>
    <h3 class="phairify-heading-h3 phairify-color-nave mb-3" :class="isUser ? 'v3_color_teal mb-5' : ''">
      Set New Password
    </h3>
    <b-form-group
      horizontal
      :invalid-feedback="passwordInvalidFeedback"
      label="New Password"
      :class="isUser ? 'v3_color_teal' : ''"
    >
      <b-form-input
        type="password"
        v-model="$v.password.$model"
        :state="validateState('password')"
        :class="isUser ? 'p-3 rounded_0 border_grey height_auto v3_color_black_knight form-control' : ''"
      />
    </b-form-group>
    <b-form-group
      horizontal
      :invalid-feedback="confirmPasswordInvalidFeedback"
      label="Confirm New Password"
      :class="isUser ? 'v3_color_teal' : ''"
    >
      <b-form-input
        type="password"
        v-model="$v.confirmPassword.$model"
        :state="validateState('confirmPassword')"
        :class="isUser ? 'p-3 rounded_0 border_grey height_auto v3_color_black_knight form-control' : ''"
      />
    </b-form-group>
    <div class="text-right">
      <b-button @click="submit" variant="primary" :disabled="saveLoading">
        <template v-if="!saveLoading">Save New Password</template>
        <template v-else>
          <b-spinner small />
          <span>Saving...</span>
        </template>
      </b-button>
    </div>
  </b-form>
</template>

<script>
import Api from '@/providers/Api.js';
import { validationMixin } from 'vuelidate';
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Help from '@/providers/Help';

export default {
  name: 'NewPasswordForm',
  mixins: [validationMixin],
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      password: null,
      confirmPassword: null,
      saveLoading: false,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  computed: {
    passwordInvalidFeedback: function () {
      return !this.$v.password.minLength
        ? 'Password should be at least 8 characters'
        : 'This field is required';
    },
    confirmPasswordInvalidFeedback: function () {
      return !this.$v.confirmPassword.sameAsPassword
        ? 'Passwords should match'
        : 'This field is required';
    },
    isUser: function() {
     return this.$store.getters.userIsMSSUser ? true : false;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    submit: function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }
      Help.confirm.show(
        'Are you sure you want to set a new password?',
        'Yes',
        () => {
          this.saveNewPassword();
        }
      );
    },
    saveNewPassword: async function () {
      this.saveLoading = true;
      if(this.$store.getters.userIsMSSUser || this.$store.getters.userIsMSSRecruiter){
        try {
          await Api.UpdatePasswordByUser(
            this.password,
            this.confirmPassword
          );
          this.$toasted.success('Password updated', { duration: 3000 });
          this.password = null;
          this.confirmPassword = null;
          this.$v.$reset();
        } catch (response) {
          handleServerErrorWithValidation(response, this.$toasted);
        } finally {
          this.saveLoading = false;
        }
      }else{
        try {
          await Api.saveNewPasswordByAdmin(
            this.userId,
            this.password,
            this.confirmPassword
          );
          this.$toasted.success('Password updated', { duration: 3000 });
          this.password = null;
          this.confirmPassword = null;
          this.$v.$reset();
        } catch (response) {
          handleServerErrorWithValidation(response, this.$toasted);
        } finally {
          this.saveLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped></style>
